import { useTranslation } from 'react-i18next';

import { Spinner } from '@/shared/ui';

/** Shown while a lazily imported route chunk is in flight. */
export function RouteFallback() {
  const { t } = useTranslation();

  return (
    <div className="grid min-h-[40vh] place-items-center">
      <Spinner size="lg" label={t('common.loading')} className="text-[var(--brand)]" />
    </div>
  );
}
